import React from 'react';
import { format, isToday, parseISO } from 'date-fns';

export const DATE_FORMATS = Object.freeze({
  MMM_DD_YYYY_HHmmss_A: 'MMM dd, yyyy, h:mm:ss a',
  MMM_DD_YYYY_HHmm_A: 'MMM dd, yyyy, h:mm a',
  MMMM_d_YYYY: 'MMMM d, yyyy',
  mmss: 'mm:ss',
});

export const parseDate = (
  date,
  dateFormat = DATE_FORMATS.MMM_DD_YYYY_HHmmss_A,
  recentlyFormat,
) => {
  try {
    const isoDate = parseISO(date);
    const formatSelected = (isToday(isoDate) && recentlyFormat) ? 'h:mm a' : dateFormat;

    // Default: Aug 15, 2022 8:46:46 AM
    const res = format(isoDate, formatSelected);
    return res;
  } catch (_) {
    return '';
  }
};

const WbDate = ({ date, format, recentlyFormat }) => {
  if (!date) {
    return null;
  }
  return <>{parseDate(date, format, recentlyFormat)}</>;
};

WbDate.defaultProps = {
  format: DATE_FORMATS.MMM_DD_YYYY_HHmmss_A,
  recentlyFormat: false,
};

export default WbDate;
